"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Frame = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { d: "M10 8v1H7v3H6V8h4zM18.001 16v-4h-1v3h-3v1h4z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M.654 4A1.98 1.98 0 00.52 5.121L.94 6.64a2 2 0 01-.012.72l-.614 3.073a8 8 0 000 3.136l.614 3.073a2 2 0 01.012.72L.52 18.88A1.98 1.98 0 00.654 20c.246.566.746.995 1.346 1.148.327.084.683.086 1.042-.017l2.069-.877a2 2 0 011.659.259l1.12.747a2 2 0 002.22 0l.78-.52a2 2 0 012.22 0l.78.52a2 2 0 002.22 0l1.12-.747a2 2 0 011.66-.259l2.068.877c.36.103.716.1 1.042.017.6-.153 1.1-.582 1.346-1.148a1.98 1.98 0 00.134-1.121l-.42-1.517a2 2 0 01.012-.721l.614-3.072a8.001 8.001 0 000-3.138l-.614-3.072a2 2 0 01-.012-.72l.42-1.518A1.98 1.98 0 0023.346 4 2.022 2.022 0 0022 2.852a1.983 1.983 0 00-1.042.017l-2.069.877a2 2 0 01-1.659-.259l-1.12-.747a2 2 0 00-2.22 0l-.78.52a2 2 0 01-2.22 0l-.78-.52a2 2 0 00-2.22 0l-1.12.747a2 2 0 01-1.66.259l-2.068-.877A1.984 1.984 0 002 2.852C1.4 3.005.9 3.434.654 4zM20 6H4v12h16V6z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Frame;
